import React from "react";
// import log from "@hrtps/log";
import { get } from "lodash";
import { Modal } from "antd";
import storage from "libs/storage";
import { isLogin } from "libs/wutianTeamsLogin";

window.addEventListener("error", (e) => {
  console.log("window error catch: ", e)
//   log.init({
//     env: process.env.REACT_APP_ENV || "DEV",
//     tenantId: "SSC-C-PC",
//     serviceCode: "SSC-C-PC",
//   });
//   log.info(`[error listener: ${get(e, "message")}]`);
  if (/Loading chunk [\d]+ failed/.test(get(e, "message"))) {
    const refreshCount = Number(storage.getItem("refreshCount"));
    const isNumberCount = Number.isSafeInteger(refreshCount);
    const isValidCount = refreshCount >= 0 && refreshCount <= 4;
    if (!isNumberCount) {
      storage.setItem("refreshCount", 4);
    }
    if (isNumberCount && !isValidCount) {
      return;
    }
    if (isNumberCount && isValidCount) {
      storage.setItem("refreshCount", refreshCount - 1);
    }
    // let secondsToGo = 5;
    const modal = Modal.success({
      title: `发现新版本，正在更新...`,
      okButtonProps: {
        loading: true,
      },
    });
    console.log("isLogin: ", isLogin());
    console.log("url: ", window.location.href);
    // const timer = setInterval(() => {
    //   secondsToGo -= 1;
    //   modal.update({
    //     title: `发现新版本，正在更新${secondsToGo}s...`,
    //   });
    // }, 1000);
    setTimeout(() => {
      //   clearInterval(timer);
      modal.destroy();
      window.location.reload();
    }, 5000);
  }
});

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    console.log("error catch", error, errorInfo);
    // log.init({
    //   env: process.env.REACT_APP_ENV || "DEV",
    //   tenantId: "SSC-C-PC",
    //   serviceCode: "SSC-C-PC",
    // });
    // log.error(JSON.stringify(errorInfo));
  }

  render() {
    // if (this.state.hasError) {
    //   // You can render any custom fallback UI
    //   return <h1>Something went wrong.</h1>;
    // }

    return this.props.children;
  }
}
